import { bootstrapApplication } from '@angular/platform-browser';
import { init, replayIntegration } from '@sentry/angular';
import { App } from './app/app';
import { appConfig } from './app/app.config';

init({
  dsn: 'https://17cf4322067fc66e94edf1258686714e@o4510352091709440.ingest.us.sentry.io/4510352092626944',
  sendDefaultPii: true,
  integrations: [replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: false,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
